export const samlSuccessRoute = "/saml";
export const samlTokenParameterName = `token`;
export const samlMobileTokenParameterName = `samlToken`;
export const samlIsNewUserParameterName = "isNewUser";
export const samlUserId = "userId";
export const mobileSamlSuccessPath = "deskbird://auth";
export const mobileSamlPlatforms = ["ios", "android"];
